import {
  isAkaCriticalIllnessCoInsuredSelected,
  isAkaCriticalIllnessInsuredSelected,
  isAkaGroupLifeCoInsuredSelected,
  isAkaGroupLifeDeathCoInsuredSelected,
  isAkaGroupLifeDeathSelected,
  isAkaGroupLifeIncapacityCoInsuredSelected,
  isAkaGroupLifeIncapacitySelected,
  isAkaGroupLifeInsuredSelected,
  isAkaGroupLifeTimeCoInsuredSelected,
  isAkaGroupLifeTimeSelected,
} from "./mapToCartProducts";

import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import {
  AkaCriticalIllness,
  AkaGroupLifeCoverage,
} from "Store/interfaces/products/coverage";

export const AKA_GROUP_LIFE = "AKA_GROUP_LIFE_";
export const getAkaGroupLifeCoverageGroup = (
  priceFormData: AkaAdvicePriceFormValues,
): AkaGroupLifeCoverage => {
  if (akaGroupLifeInsuredOnly(priceFormData)) {
    return AkaGroupLifeCoverage[
      `${AKA_GROUP_LIFE}${getInsuredOnlyCov(priceFormData)}`
    ];
  } else if (akaGroupLifeCoInsuredOnly(priceFormData)) {
    return AkaGroupLifeCoverage[
      `${AKA_GROUP_LIFE}${getCoInsuredOnlyCov(priceFormData)}`
    ];
  }
  return AkaGroupLifeCoverage[
    `${AKA_GROUP_LIFE}${getInsuredAndCoInsuredCov(priceFormData)}`
  ];
};

const akaGroupLifeInsuredOnly = (
  priceFormData: AkaAdvicePriceFormValues,
): boolean =>
  isAkaGroupLifeInsuredSelected(priceFormData) &&
  !isAkaGroupLifeCoInsuredSelected(priceFormData);
const akaGroupLifeCoInsuredOnly = (
  priceFormData: AkaAdvicePriceFormValues,
): boolean =>
  !isAkaGroupLifeInsuredSelected(priceFormData) &&
  isAkaGroupLifeCoInsuredSelected(priceFormData);

enum IncapAndDeathCovType {
  INCAP_AND_DEATH = "INCAP_AND_DEATH",
}
enum DeathAndIncapCovType {
  DEATH_AND_INCAP = "DEATH_AND_INCAP",
}
enum BaseCovType {
  ALL = "ALL",
  DEATH = "DEATH",
  INCAP = "INCAP",
  INCAP_AND_TIME = "INCAP_AND_TIME",
}
type CovType<AndCo extends boolean | undefined = undefined> = AndCo extends true
  ? BaseCovType | IncapAndDeathCovType
  : BaseCovType | DeathAndIncapCovType;

function getCovType<TAndCo extends boolean | undefined = undefined>(
  death: boolean,
  incap: boolean,
  time: boolean,
  andCo?: TAndCo,
): CovType<TAndCo> {
  if (death) {
    if (incap) {
      if (time) {
        return BaseCovType.ALL;
      }
      return (
        andCo
          ? IncapAndDeathCovType.INCAP_AND_DEATH
          : DeathAndIncapCovType.DEATH_AND_INCAP
      ) as CovType<TAndCo>;
    }
    return BaseCovType.DEATH;
  }
  if (incap) {
    if (time) {
      return BaseCovType.INCAP_AND_TIME;
    }
    return BaseCovType.INCAP;
  }
  throw new Error(
    "getCovType - Unable to return coverage type for aka group life",
  );
}

export const getInsuredOnlyCov = (
  priceFormData: AkaAdvicePriceFormValues,
): CovType =>
  getCovType(
    isAkaGroupLifeDeathSelected(priceFormData),
    isAkaGroupLifeIncapacitySelected(priceFormData),
    isAkaGroupLifeTimeSelected(priceFormData),
  );

const CO_ONLY = "_CO";
type CoInsuredOnlyCovType = `${CovType}${typeof CO_ONLY}`;
export const getCoInsuredOnlyCov = (
  priceFormData: AkaAdvicePriceFormValues,
): CoInsuredOnlyCovType => {
  return `${getCovType(
    isAkaGroupLifeDeathCoInsuredSelected(priceFormData),
    isAkaGroupLifeIncapacityCoInsuredSelected(priceFormData),
    isAkaGroupLifeTimeCoInsuredSelected(priceFormData),
  )}${CO_ONLY}`;
};

const AND_CO = "_AND_CO_";
type InsuredAndCoInsuredCovType = `${CovType<true>}${typeof AND_CO}${CovType}`;
export const getInsuredAndCoInsuredCov = (
  priceFormData: AkaAdvicePriceFormValues,
): InsuredAndCoInsuredCovType => {
  return `${getCovType(
    isAkaGroupLifeDeathSelected(priceFormData),
    isAkaGroupLifeIncapacitySelected(priceFormData),
    isAkaGroupLifeTimeSelected(priceFormData),
    true,
  )}${AND_CO}${getCovType(
    isAkaGroupLifeDeathCoInsuredSelected(priceFormData),
    isAkaGroupLifeIncapacityCoInsuredSelected(priceFormData),
    isAkaGroupLifeTimeCoInsuredSelected(priceFormData),
  )}`;
};

export const getAkaCriticalIllnessCoverageGroup = (
  priceFormData: AkaAdvicePriceFormValues,
): AkaCriticalIllness => {
  if (isAkaCriticalIllnessInsuredOnly(priceFormData)) {
    return AkaCriticalIllness.AKA_CRITICAL_ILLNESS;
  }
  if (isAkaCriticalIllnessCoInsuredOnly(priceFormData)) {
    return AkaCriticalIllness.AKA_CRITICAL_ILLNESS_CO_INSURED;
  }
  return AkaCriticalIllness.AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED;
};

const isAkaCriticalIllnessInsuredOnly = (
  priceFormData: AkaAdvicePriceFormValues,
): boolean =>
  isAkaCriticalIllnessInsuredSelected(priceFormData) &&
  !isAkaCriticalIllnessCoInsuredSelected(priceFormData);

const isAkaCriticalIllnessCoInsuredOnly = (
  priceFormData: AkaAdvicePriceFormValues,
): boolean =>
  !isAkaCriticalIllnessInsuredSelected(priceFormData) &&
  isAkaCriticalIllnessCoInsuredSelected(priceFormData);
